export enum CardMode {
  DEFAULT = "DEFAULT",
  THREE_QUARTHER = "THREE_QUARTER",
  FULL = "FULL",
}
